import api from '@/plugins/axios'

// Upload image to backend and return a URL string for Tiptap (<img src="...">)
export async function tiptapUploadImage(file) {
  if (file && file.size > 5 * 1024 * 1024) {
    throw new Error('Image is larger than 5 MB')
  }
  const form = new FormData()
  form.append('file', file) // matches UploadedImage.file

  let resp
  try {
    // Use the SAME endpoint that worked for Quill
    resp = await api.post('/api/uploads/images/', form, {
      withCredentials: true,
    })
  } catch (err) {
    console.error('[tiptapUploadImage] upload failed:', err)
    const msg = err?.response?.data?.detail || err?.message || 'Upload failed'
    throw new Error(msg)
  }

  const data = resp?.data || {}
  // Prefer explicit url, then file/file_url as in your Quill helper
  let raw = data.url ?? data.file ?? data.file_url ?? null

  // Normalize any absolute /media/... URL to a relative one
  const toRelative = (url) => {
    if (typeof url !== 'string' || !url) return url
    try {
      const u = new URL(url, window.location.origin)
      if (u.pathname.startsWith('/media/')) {
        return u.pathname + u.search + u.hash
      }
      return url // leave external/CDN URLs untouched
    } catch {
      return url // already relative or not a full URL
    }
  }

  const rel = toRelative(raw)
  if (typeof rel === 'string' && rel) return rel
  throw new Error('No URL returned from upload')
}